import React, { useEffect } from "react";
import Headertop from '../components/Headertop';
import Navbar from '../components/Navbar';
import Header from '../components/SubHeader-Course';
import Footer from '../components/Footer';
import { Link } from "react-router-dom";
import '../components/css/buttonStyle.css';
import paper1 from '../components/question-answer-pdf/HPSC-Assistant Professor-Exam2018.pdf';
import paper2 from '../components/question-answer-pdf/HPSC-Assistant Professor-Exam2025.pdf';
import add2 from '../components/advertisment/Asstright.png';
import add1 from '../components/advertisment/asstbottom.png';

function AssistantprofessorCourse (){
    /* ===== SCROLL EFFECT ===== */
    useEffect(() => {
    const handleScroll = () => {
        const banner = document.querySelector(".footerimg");
        if (!banner) return;
            if (window.scrollY > 200) {
                banner.classList.add("show");
            } 
            else {
                banner.classList.remove("show");
            }
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    
    return (
        <>
            <Headertop /> 
            <Navbar />
            <Header />
            <div className="container my-5">
                <div className="row g-4">
                    <div className="col-lg-9">
                        <div className="row g-4">
                            <p>The HPSC Assistant Professor selection process includes a written examination and Interview. To improve their HPSC Assistant Professor exam scores, candidates should practice various HPSC Assistant Professor previous year papers. By now, aspirants should have begun their preparations; if not, don't worry; we're here to assist. We have a few HPSC Assistant Professor previous year question papers available for the candidates. HPSC Assistant Professor previous year papers will benet candidates because they will be able to practice a variety of questions and get a sense of the types of questions that will be asked on the HPSC Assistant Professor exam. By practicing with a variety of question sets, candidates can boost their condence, accuracy, and response time. HPSC Assistant Professor previous year question papers are available by clicking on the links below.</p>
                        </div>

                        <div className="yearbox mt-5 mb-5">
                            <p><b>Assistant Professor HPSC Question Paper (Total Tests: 3)</b></p>
                            <div className="downloadcards mb-3">
                                <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                    <div className="">
                                        <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                        <h5 className="fw-bold mb-1">HPSC Assistant Professor Exam. 2018</h5>
                                    </div>
                                    <div className="d-flex gap-2">
                                        <a href={paper1} rel="noopener noreferrer" target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</a>
                                        <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                    </div>
                                </div>
                            </div>

                            <div className="downloadcards mb-3">
                                <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                    <div className="">
                                        <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                        <h5 className="fw-bold mb-1">HPSC Assistant Professor Exam. 2025</h5>
                                    </div>
                                    <div className="d-flex gap-2">
                                        <a href={paper2} rel="noopener noreferrer" target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</a>
                                        <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <p>HPSC Assistant Professor Recruitment 2025: HPSC Assistant Professor Recruitment 2025 has been officially announced for 2424 teaching vacancies across various government colleges in Haryana. The recruitment is conducted by the Haryana Public Service Commission (HPSC). Interested candidates must have a Master’s degree with at least 55% marks along with a PhD or NET/SLET/SET qualification as per UGC norms. The selection process includes a Screening Test, Subject Knowledge Test, and Interview. The application process was conducted online from 1 to 15 March 2025. Candidates are advised to read here for exam schedules, vacancy details.</p>

                        <h4>HPSC Assistant Professor Recruitment 2025 Overview</h4>
                        <p>HPSC Assistant Professor Recruitment 2025 notification has been released for 2424 teaching posts in Haryana colleges. Candidates who meet the eligibility criteria can apply online through the official website. The recruitment process includes a screening test, subject knowledge test, and interview. Check the table below for an overview of the HPSC Assistant Professor Recruitment 2025.</p>

                        <table class="table table-bordered">
                            <tbody>
                                <tr><th colspan="2">HPSC Assistant Professor Recruitment 2025 Overview</th></tr>
                                <tr><th>Category</th><th>Details</th></tr>
                                <tr><td>Conducting Body</td><td>Haryana Public Service Commission (HPSC)</td></tr>
                                <tr><td>Post Name</td><td>Assistant Professor</td></tr>
                                <tr><td>Advt No.</td><td>42-67/ 2024</td></tr>
                                <tr><td>Vacancies</td><td>2424</td></tr>
                                <tr><td>Department</td><td>Higher Education Department, Haryana</td></tr>
                                <tr><td>Mode of Application</td><td>Online</td></tr>
                                <tr><td>Dates of Application</td><td>6 to 12 November 2024</td></tr>
                                <tr><td>Extended Application Date</td><td>1 to 15 March 2025</td></tr>
                                <tr><td>Job Location</td><td>Haryana</td></tr>
                                <tr><td>Exam Date Notice</td><td>Click Here</td></tr>
                                <tr><td>Music Vocal Exam Schedule</td><td>Click here</td></tr>
                                <tr><td>Music Instrumental Exam Schedule PDF</td><td>Click here</td></tr>
                                <tr><td>Fine Arts Exam Schedule PDF</td><td>Click here</td></tr>
                                <tr><td>Skill Test Exam date Reschedule PDF</td><td>Click here</td></tr>
                                <tr><td>Exam Schedule Notice 1</td><td>Click here</td></tr>
                                <tr><td>Exam Schedule Notice 2</td><td>Click here</td></tr>
                                <tr><td>Application Fees</td><td>
                                    <ul>
                                        <li>General Male - Rs. 1000</li>
                                        <li>Women/SC/ST/EWS - Rs. 250</li>
                                        <li>PH- Free</li>
                                    </ul>
                                </td></tr>
                                <tr><td>Official Website</td><td>hpsc.gov.in</td></tr>
                            </tbody>
                        </table>

                        <h5>Join CSIR NET Online Coaching – Enroll Now!</h5>

                        <h4>HPSC Assistant Professor Recruitment 2025 PDF</h4>
                        <p>HPSC Assistant Professor Recruitment 2025 PDF contains all the important details about the recruitment process. It includes information like the number of vacancies, eligibility criteria, selection process, exam pattern, and application dates. Candidates should download and read the PDF carefully before applying. Click on the given below link to download the HPSC Assistant Professor Recruitment 2025 PDF.</p>

                        <h5>HPSC Assistant Professor Recruitment 2025 PDF</h5>

                        <h4>HPSC Assistant Professor Vacancy 2025</h4>
                        <p>HPSC Assistant Professor Vacancy 2025 has been officially released for various subjects across Haryana colleges. A total of 2424 vacancies are available this year. Check the subject-wise vacancy details in the table below:</p>

                        <table class="table table-bordered">
                            <tbody>
                                <tr><th colspan="2">HPSC Assistant Professor Vacancy 2025</th></tr>
                                <tr><th>Name of Subjects</th><th>No. of Vacancies</th></tr>
                                <tr><td>Botany</td><td>98</td></tr>
                                <tr><td>Chemistry</td><td>123</td></tr>
                                <tr><td>Commerce</td><td>153</td></tr>
                                <tr><td>Computer Science</td><td>47</td></tr>
                                <tr><td>Defence Studies</td><td>23</td></tr>
                                <tr><td>Economics</td><td>43</td></tr>
                                <tr><td>English</td><td>613</td></tr>
                                <tr><td>Environment Science</td><td>7</td></tr>
                                <tr><td>Fine Arts</td><td>7</td></tr>
                                <tr><td>Geography</td><td>316</td></tr>
                                <tr><td>Hindi</td><td>139</td></tr>
                                <tr><td>History</td><td>123</td></tr>
                                <tr><td>Home Science</td><td>28</td></tr>
                                <tr><td>Mass Communication</td><td>8</td></tr>
                                <tr><td>Music</td><td>14</td></tr>
                                <tr><td>Philosophy</td><td>3</td></tr>
                                <tr><td>Physical Education</td><td>126</td></tr>
                                <tr><td>Physics</td><td>96</td></tr>
                                <tr><td>Political Science</td><td>81</td></tr>
                                <tr><td>Psychology</td><td>85</td></tr>
                                <tr><td>Punjabi</td><td>24</td></tr>
                                <tr><td>Sanskriti</td><td>12</td></tr>
                                <tr><td>Tourism</td><td>1</td></tr>
                                <tr><td>Zoology</td><td>91</td></tr>
                                <tr><td>Total</td><td>2424</td></tr>
                            </tbody>
                        </table>

                        <h4>HPSC Assistant Professor Exam Date 2025</h4>
                        <p>Candidates who have applied for the HPSC Assistant Professor Exam 2025 can check the exam dates for various subjects below. The exam schedule includes Subject Knowledge Tests and Screening Tests for different subjects.</p>

                        <table class="table table-bordered">
                            <tbody>
                                <tr><th colspan="3">HPSC Assistant Professor Exam Date 2025</th></tr>
                                <tr><th>Exam Type</th><th>Subjects</th><th>Exam Date</th></tr>
                                <tr><td>Subject Knowledge Test	Music (Vocal), Music (Instrumental), Philosophy, Tourism,</td><td>Fine Arts</td><td>From 25 April 2025</td></tr>
                                <tr><td>Screening & Subject Knowledge Test</td><td>Physical Education, Defence Studies, Mass Communication, Punjabi</td><td>From 27 April 2025</td></tr>
                                <tr><td>Screening Test</td><td>Botany, Zoology, Chemistry, Physics</td><td>4 May 2025, 11 May 2025</td></tr>
                            </tbody>
                        </table>


                        <h4>HPSC Assistant Professor Eligibility Criteria 2025</h4>
                        <p>HPSC Assistant Professor Eligibility Criteria 2025 are set by the Haryana Public Service Commission to ensure only qualified candidates apply. Check the detailed eligibility conditions given below before submitting your application:</p>
                        <ul>
                        <li>●Educational Qualification: Candidates should have a Master’s degree in the relevant subject with at least 55% marks from a recognized university. Along with this, they must have either a PhD or have qualified NET/SLET/SET as per UGC rules.</li>
                        <li>●Age Limit: Applicants must be between 21 to 42 years old. Age relaxation is available for candidates from reserved categories as per the Haryana government rules.</li>
                        <li>●Nationality: Only Indian citizens are eligible to apply for the HPSC Assistant Professor post.</li>
                        </ul>

                        <h4>HPSC Assistant Professor Apply Link 2025</h4>
                        <p>HPSC Assistant Professor Application Form 2025 was initially released on 30 October 2024. The application link was reactivated on 1 March 2025, giving candidates another chance to apply. However, the last date to submit the form was 15 March 2025. Now, the application process is officially closed.</p>

                        <h4>HPSC Assistant Professor Application Fees 2025</h4>
                        <p>HPSC Assistant Professor Application Fees 2025 are different for various categories. Candidates must pay the required fee while submitting the online application form. Check the fee details below:</p>

                        <table class="table table-bordered">
                            <tbody>
                                <tr><th colspan="2">HPSC Assistant Professor Application Fees 2025</th></tr>
                                <tr><th>Category</th><th>Fees</th></tr>
                                <tr><td>General</td><td>Rs. 1000</td></tr>
                                <tr><td>Women/SC/ST/PwD</td><td>Rs. 250</td></tr>
                            </tbody>
                        </table>


                        <h4>HPSC Assistant Professor Admit Card 2025</h4>
                        <p>HPSC Assistant Professor Admit Card 2025 has been released for the Screening and Subject Knowledge Tests. Candidates can download their admit cards from the official website. The Subject Knowledge Test for Music (Vocal), Music (Instrumental), Philosophy, Tourism, and Fine Arts will begin on 25 April 2025, while the Screening and Subject Knowledge Test for Physical Education, Defence Studies, Mass Communication, and Punjabi will start on 27 April 2025. Click on the given below link to download the HPSC Assistant Professor Admit Card 2025.</p>
                        <p><b>HPSC Assistant Professor Admit Card 2025 Download Link</b></p>

                        <h4>HPSC Assistant Professor Selection Process 2025</h4>
                        <p>HPSC Assistant Professor Selection Process 2025 includes different stages to check the candidate’s knowledge and teaching skills. Check these stages given below for selection process:</p>

                        <h5>Screening Test</h5>
                        <p>The first stage is the Screening Test. It is an objective-type test with questions on general knowledge, reasoning, and basic subject topics. It helps to shortlist candidates for the next stage. Scoring well in this test is important to move forward.</p>

                        <h5>Subject Knowledge Test</h5>
                        <p>Candidates who pass the screening test appear for the Subject Knowledge Test. This test checks the candidate’s deep understanding of their subject. It includes descriptive questions. Doing well in this stage shows that the candidate is ready to teach at the college level.</p>

                        <h5>Interview</h5>
                        <p>The final stage is the Interview. It checks the candidate’s teaching skills, communication, and overall personality. A panel of experts conducts the interview. This stage is important for the final selection.</p>
                        {/* <img src={add1} className="courseBanner" alt="" /> */}
                    </div>

                    <div className="col-lg-3">
                        <div className="sidebar-box">
                            <h5>Search</h5>
                            <div className="input-group mt-3">
                                <input type="text" className="form-control" placeholder="Enter Keyword" />
                                <button className="btn btn-light"><i className="bi bi-search"></i></button>
                            </div>
                        </div>
                        <div className="sidebar-box">
                            <h5>Recent Posts</h5>
                            <div className="recent-post mt-3">
                                <ul className="list-unstyled">
                                    <li><Link to="/Upgiclecturerrecruitment2025">UP GIC Lecturer Recruitment 2025 Apply Online, Eligibility, Fee, Last Date</Link></li>
                                    <li><Link to="/RPSCSchoollecturer2025">RPSC School Lecturer Recruitment 2025 [3225 Post] Apply Online</Link></li>
                                    <li><Link to="/GATEExamination2026">GATE Examination 2026</Link></li>
                                    <li><Link to="/BiharBPSCAESRecruitment2025">Read More</Link></li>
                                </ul>
                                <div>
                                    <p className="mb-0"></p>
                                </div>
                            </div>
                            {/* <style>
                                .courseBanner {
                                    position: fixed;
                                    bottom: -150px; 
                                    right: 20px;               
                                    width: 300px;              
                                    transition: all 0.6s ease;
                                    z-index: 999;
                                }
                                .courseBanner.show {
                                    bottom: 0;
                                }
                            </style> */}
                            <img src={add2} className="courseBanner" alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
            <img src={add1} className="footerimg" alt="" />
        </>
    );
}
export default AssistantprofessorCourse;